export default __webpack_public_path__ + "static/pict4-989e79b126f45936033f85fe5f5208c7.png";